import { Outlet } from 'react-router-dom';
import { PageContainer } from './page-container';
import { ReportsMenu } from '../reports-menu/reports-menu';
import { PageContentAnimation } from './page-content-animation';
import { useState } from 'react';
import { FaChevronRight } from 'react-icons/fa6';
import classNames from 'classnames';

export function ReportPageLayout() {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <PageContentAnimation>
      <PageContainer>
        <div className={classNames('grid gap-5', isOpen ? 'lg:grid-cols-[320px_1fr]' : 'lg:grid-cols-[0_1fr]')}>
          <aside className="flex flex-col gap-5 overflow-y-auto scroll-smooth">
            <ReportsMenu isOpen={isOpen} setIsOpen={setIsOpen} />
            <button
              onClick={() => setIsOpen(true)}
              className={classNames(
                'absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-surface-elevated p-2 rounded-r-lg hover:bg-brand-primary-hover transition-colors',
                isOpen ? 'opacity-0 pointer-events-none' : 'opacity-100',
              )}
            >
              <FaChevronRight className="text-white w-4 h-4" />
            </button>
          </aside>
          <Outlet />
        </div>
      </PageContainer>
    </PageContentAnimation>
  );
}
